import * as React from "react";
import styles from "./layout.module.css";
import { GridFull } from "~components/Grid/GridFull";
import { GridLayout } from "~components/Grid/GridLayout";
import { GridLeftContent } from "~components/Grid/GridLeftContent";
import { GridCenterContent } from "~components/Grid/GridCenterContent";
import { GridRightContent } from "~components/Grid/GridRightContent";

type Props = {
  leftRail?: React.ReactNode;
  contentWell: React.ReactNode;
  rightRail?: React.ReactNode;
  recirc?: React.ReactNode;
};

export function Layout({ leftRail, contentWell, rightRail, recirc }: Props) {
  return (
    <div className={styles.gridLayoutContainer}>
      <GridLayout>
        <GridLeftContent>{leftRail}</GridLeftContent>
        <GridCenterContent>{contentWell}</GridCenterContent>
        <GridRightContent>{rightRail}</GridRightContent>
        <GridFull>{recirc}</GridFull>
      </GridLayout>
    </div>
  );
}
